import {Component} from 'react';
import TransactionHistoryByAccountType from './transaction_history_by_account_type';
import calculateInvestTotalByTranType from './investments/objects/calculate_invest_totals_by_tran_type';
import InvestmentTransactionHistoryModal from './investments/investment_transaction_history_modal';
import SavingsTransactionHistoryModal from './savings/savings_transaction_history_modal';
import getCurrentPriceArr from './xMoneyBuilderObjects/get_current_price_arr';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import {buildUrl} from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';
import createTranTotalArrays from './xMoneyBuilderObjects/create_tran_total_arrays';

class TransactionHistoryMain extends Component {
    constructor(props) {
        super(props);
        this.moneyBuildInfo = this.props.moneyBuildInfo();
        this.state = {
            open: false, 
            openInvestmentHistoryModal: false,     
            openSavingsTransactionModal: false,
            savingTransLoaded: false,
            headers: setHeadersForFetch(),
            environment: Config.dataURL.currentEnv,
            subProcess: "TransactionHistoryMain",
        };
        this.displayInvestments = false;
        this.showFilter = false;
        this.savingTransData = [];
        this.totalByTranTypeArr = [];
        this.calculateTotalsComplete = false;
        this.waitState = true;
        this.currentPriceArr = [];
        this.initializeInformation();
    }

    initializeInformation(){
        this.determineClassValues();
    }

    determineClassValues(){
        this.classSize = "col-sm-8 mt-1";
        this.tableClass = "table table-hover table-no-space moneyBuilder-text-class";
    }
    
    createTransactionSummaryArrays(){
        let investmentTotalByTypeArr = [];
        this.totalByTranTypeArr = [];
        this.bankByTypeArr = [];
        this.retirementByTypeArr = [];
        this.savingsInvestmentsExist = false;
        this.savingsExist = false;
        this.investmentsExist = false;
        this.summaryTranArr = [];
        if (this.savingTransData.length > 0){
            if (this.moneyBuildInfo.savingsInfo.gameID){
                this.savingsExist = true;
                const summaryTranArr = JSON.parse(JSON.stringify(this.moneyBuildInfo.savingsInfo.savingsArr));
                let savingsTypeArr = [];
                let maxIndx = summaryTranArr.length - 1;
                // this ensures there is one (and only one) of different savings type records
                // going thru backwards so most current will be selected if there are multiple
                for (let i=maxIndx; i>=0; i--){
                    if (savingsTypeArr.includes(summaryTranArr[i].savingsType)){
                        // skip this entry - it's already in the table
                    }else{
                        savingsTypeArr.push(summaryTranArr[i].savingsType);
                        this.summaryTranArr.push(summaryTranArr[i]);
                    }
                }
                this.summaryTranArr = this.summaryTranArr.filter(elem => elem.closedDate === "");
                let savingTranArr = JSON.parse(JSON.stringify(this.savingTransData));
                const gameYear = this.moneyBuildInfo.gameData.currentGameDate.split("-")[0];
                let summaryArrays = createTranTotalArrays(this.summaryTranArr, "bank", gameYear, savingTranArr);
                this.totalByTranTypeArr = summaryArrays.totalByTypeArr;
                this.bankByTypeArr = summaryArrays.savingsTypeTotalArr;
                this.currentPriceArr = getCurrentPriceArr(this.moneyBuildInfo.gameData.gameNbrMonths);
                summaryArrays = createTranTotalArrays(this.summaryTranArr, "retirement", gameYear, savingTranArr,
                    this.currentPriceArr);
                this.totalByTranTypeArr = this.totalByTranTypeArr.concat(summaryArrays.totalByTypeArr);
                this.retirementByTypeArr = summaryArrays.savingsTypeTotalArr;
            }
        }
           
        const emptyTranArr =  [{tranType: "", tranYear: "all", tranAmt: 0}]
        if (this.bankByTypeArr.length === 0){
            const savingsTotalByTypeObj = {accountType: "bank", imageURL: "Savings/savings.png", 
                totalArr: emptyTranArr};
            this.totalByTranTypeArr.push(savingsTotalByTypeObj);
        }
        if (this.retirementByTypeArr.length === 0){
            const savingsTotalByTypeObj = {accountType: "retirement", imageURL: "Savings/saving401K.png", 
                totalArr: emptyTranArr};
            this.totalByTranTypeArr.push(savingsTotalByTypeObj);
        }
        if (this.moneyBuildInfo.gameInvestments &&
            this.moneyBuildInfo.gameInvestments.length > 0){
            investmentTotalByTypeArr = [];
            for (let i=0; i<this.moneyBuildInfo.gameInvestments.length; i++){
                this.investmentsExist = true;
                let totalArr = [];
                let tranArr = this.moneyBuildInfo.gameInvestments[i].transactionArr;
                totalArr = calculateInvestTotalByTranType(tranArr, "active", investmentTotalByTypeArr, totalArr);
                tranArr = this.moneyBuildInfo.gameInvestments[i].historyTranArr;
                totalArr = calculateInvestTotalByTranType(tranArr, "history", investmentTotalByTypeArr, totalArr);
                tranArr = this.moneyBuildInfo.gameInvestments[i].taxHistoryArr;
                totalArr = calculateInvestTotalByTranType(tranArr, "tax", investmentTotalByTypeArr, totalArr)
                investmentTotalByTypeArr = totalArr;
            }
        }
        if (investmentTotalByTypeArr.length > 0){
            const investmentTotalByTypeObj = {accountType: "investments", 
                imageURL: "Investments/investments.png", totalArr: investmentTotalByTypeArr};
            this.totalByTranTypeArr.push(investmentTotalByTypeObj);
            investmentTotalByTypeArr = investmentTotalByTypeArr.sort((a, b) => (a.tranType > b.tranType) ? 1 : -1)
        }else{
            const investmentTotalByTypeObj = {accountType: "investments", 
                imageURL: "Investments/investments.png", totalArr: emptyTranArr};
            this.totalByTranTypeArr.push(investmentTotalByTypeObj);
        }

               
        if (this.totalByTranTypeArr.length > 0){
            this.displayInvestments = true;
        }
        this.calculateTotalsComplete = true;
        this.waitState = false;
    }
    
    displayDetailTranHistory(accountType){
        this.accountType = accountType;
        if (accountType === "investments" ){
            this.setState({openInvestmentHistoryModal: true});
        }
        this.selectSavingsInfo = 
            this.moneyBuildInfo.savingsInfo.savingsArr.filter(elem => elem.savingsClass === accountType);
        this.selectSavingTransData = 
            this.savingTransData.filter(elem => elem.savingsClass === accountType);
        if (accountType === "bank" || accountType === "retirement"){
            this.setState({openSavingsTransactionModal: true});
            if (accountType === "bank"){
                this.summaryArr = this.bankByTypeArr;
            }else{
                this.summaryArr = this.retirementByTypeArr;
            }
        }
    }

    closeModals(modalName){
        if (modalName === "investments"){
            this.setState({openInvestmentHistoryModal: false});
        }
        if (modalName === "bank" || modalName === "retirement"){
            this.setState({openSavingsTransactionModal: false});
        }
    }

    render() {
        if (this.state.savingTransLoaded === true && this.calculateTotalsComplete === false){
            this.createTransactionSummaryArrays();
        }
        this.transactionHistoryDisplay = this.totalByTranTypeArr.map((transactions, index) =>
            <TransactionHistoryByAccountType key={index} tranInfo={transactions}
                displayDetailTranHistory={(accountType) => this.displayDetailTranHistory(accountType)}
                gameDate={this.moneyBuildInfo.gameData.currentGameDate}
                savingsExist={this.savingsExist}
                investmentsExist={this.investmentsExist}
            />
        );
       
    return <>
       <div className={this.classSize}>
        <div className="card mt-2 rounded-corners-lg height-max moneyBuilder-text-size">
        <h3 className="mt-4 text-center">Transaction History</h3>
        <h5 className="mt-2 mx-4 text-center">
            Follow the money! This history shows what you earned, spent, saved, or 
            invested.
        </h5>
            {this.waitState  ?
                <WaitTimeSpinner/>
            :
                <div className="overflow-scroll mx-4 my-5 overflow-x-hidden">
                    {this.totalByTranTypeArr.length > 0 ?
                        <>
                            {this.transactionHistoryDisplay}
                        </>
                    :
                        <>
                            <h6 className="mt-2 text-center">
                                No Transaction History is available to display.  
                            </h6>
                            <h6 className="mt-2 text-center">
                                Check back after
                                you have played the game for a couple of months (turns).
                            </h6>
                        </>
                    }
                </div>
            }
            {this.state.openInvestmentHistoryModal   ?
                <InvestmentTransactionHistoryModal
                    show={this.state.openInvestmentHistoryModal}
                    onClose={() => this.closeModals("investments")}
                    onNavigate={(pathname) => this.props.onNavigate(pathname)}
                    moneyBuildInfo = {() => this.props.moneyBuildInfo()} 
                />
            :
                null
            }
            {this.state.openSavingsTransactionModal   ?
                <SavingsTransactionHistoryModal
                    show={this.state.openSavingsTransactionModal}
                    savingsClass={this.accountType}
                    onClose={() => this.closeModals("bank")}
                    currentPriceArr={this.currentPriceArr}
                    summaryArr={this.summaryArr}
                    savingsTranArr={this.selectSavingTransData}
                    savingsInfo={this.selectSavingsInfo}
                    savingsExist={this.savingsExist}
                    moneyBuildInfo = {() => this.props.moneyBuildInfo()} 
                />
            :
                null
            }

         
        </div>
    </div>   
    </>
    }

componentDidMount(){
    this._isMounted = true;
    this.loadSavingTrans();
}

loadSavingTrans(){
    const funcName = "loadSavingTrans";
    const gameID = this.moneyBuildInfo.savingsInfo.gameID;
    const urlParm = "?requestType=gameID&gameID=" + gameID;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,  
            {method:'GET', headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.savingTransData = output.body;
                    if (this._isMounted === true){
                        this.setState({savingTransLoaded: true});
                    }
                }else{
                    if (statusCode === 250){
                        if (this._isMounted === true){
                            this.setState({savingTransLoaded: true});
                        }
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message, errorObject: urlParm};
                        this.props.processError(errorObj);
                    }
                }
            });
        };
    });
}

}

export default TransactionHistoryMain;